import React from 'react';
import { createRoot } from 'react-dom/client';


import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import PreCadastro from './pages/PreCadastro';
import Entrar from './pages/Entrar';

import "primeflex/primeflex.css";

import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/themes/nova/theme.css';

import './Interceptors'

import Template from './Template';
import Loja from './pages/Loja';
import Pedidos from './pages/Pedidos';
import Perfil from './pages/Perfil';
import Carrinho from './pages/Carrinho';
import ConfirmacaoCadastroCliente from './pages/ConfirmacaoCadastroCliente';
import Pedido from './pages/Pedido';

const container = document.getElementById('root');
const root = createRoot(container);

var template;

root.render(
  <>
    <div className='App-process'>
      <div>
          <div>
              <div>

              </div>
              Aguarde...
          </div>
          
          
      </div>
    </div>
    <React.StrictMode>
        <Router>
            <Routes>
                <Route exact path="/" element={<Home />} />
                <Route path="/pre-cadastro" element={<PreCadastro />} />
                <Route path="/entrar" element={<Entrar />} />
                <Route exact path="/home" element={<Template><Home /></Template>} />
                <Route exact path="/loja" element={<Template ref={ref => {template = ref}}><Loja refreshState={() => template.refreshState()} /></Template>} />
                <Route exact path="/pedidos" element={<Template><Pedidos /></Template>} />
                <Route exact path="/perfil" element={<Template><Perfil /></Template>} />
                <Route exact path="/carrinho" element={<Template><Carrinho /></Template>} />
                <Route exact path="/pedidos" element={<Template><Pedidos /></Template>} />
                <Route exact path="/pedido/:id" element={<Template><Pedido /></Template>} />
                <Route exact path="/confirmacaocadastro" element={<ConfirmacaoCadastroCliente />} />
                
            </Routes>
        </Router>          
    </React.StrictMode>
  </>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals


